export default __webpack_public_path__ + "static/MineralSwimV2_Testimonial_Katie_NSW-781353598aaff5e0821717b1a9f5e3d5.jpg";